var _templateObject = _taggedTemplateLiteralLoose(['\n'], ['\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    background: transparent;\n    margin-top: 5px;\n    display: block;\n    width: 100%;\n    white-space: nowrap;\n    text-decoration: none;\n    color: ', ';\n    font-family: ', ';\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    text-shadow: 0 2px 4px 0 ', ';\n    :hover {\n      color: white;\n    }\n  '], ['\n    background: transparent;\n    margin-top: 5px;\n    display: block;\n    width: 100%;\n    white-space: nowrap;\n    text-decoration: none;\n    color: ', ';\n    font-family: ', ';\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    text-shadow: 0 2px 4px 0 ', ';\n    :hover {\n      color: white;\n    }\n  ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { LinkIcon } from '../Icons';
import { gold, darkGreyOpacity } from '../../assets/colors';
import { Montserrat } from '../../assets/fonts';

export var Action = styled.a.attrs(function (props) {
  return {
    href: props.to
  };
})(_templateObject);

export default (function (_ref) {
  var options = _ref.options,
      comp = _ref.comp;

  var Links = comp && options.external ? comp : Action;

  var LinksStyled = styled(Links)(_templateObject2, gold, Montserrat, darkGreyOpacity);
  return options.map(function (option) {
    return React.createElement(
      LinksStyled,
      { key: option.id, to: option.to, color: option.color, target: option.target },
      option.label,
      React.createElement(LinkIcon, null)
    );
  });
});